import { useStore } from 'effector-react'
import * as React from 'react'
import { useLocation } from 'react-router-dom'

import { $error, $gateway, gatewayMounted, getGateway } from './model'
import { $gatewayExchanger } from '../create/model'

export const useGateway = () => {
  const { pathname } = useLocation()
  const gateway = useStore($gateway)
  const loading = useStore(getGateway.pending)
  let error = useStore($error)
  const gatewayExchanger = useStore($gatewayExchanger)

  React.useEffect(() => {
    gatewayMounted()
  }, [pathname])

  return { gateway, gatewayExchanger, loading, error }
}
